// extracted by mini-css-extract-plugin
export default {"map-container":"GoogleBasedMap_map-container__pMR3-"};